import { appGridApiAtom } from "@/components/AppGrid/AppGrid";
import { analytics } from "@/firebase";
import { useIsPlanInactive } from "@/hooks/useIsPlanInactive";
import { EntityRecord, Model } from "@/orm/types";
import { ApplyColumnStateParams } from "@ag-grid-community/core";
import { Button } from "@mantine/core";
import { logEvent } from "firebase/analytics";
import { useAtomValue } from "jotai";
import { useAsyncCallback } from "react-async-hook";
import { BiSolidAddToQueue } from "react-icons/bi";

export const AppGridCreateItemButton = <T extends EntityRecord = EntityRecord>({
  model,
  applySortOnCreate = {
    state: [{ colId: "createdAt", sort: "desc" }],
    defaultState: { sort: null },
  },
  label,
}: {
  model: Model<T>;
  applySortOnCreate?: ApplyColumnStateParams;
  label?: string;
}) => {
  const { loading, execute: create } = useAsyncCallback(model.create);
  const logId = model.labels.singular.replace(/\s+/g, "_").toLowerCase();
  const name = model.labels.singular;
  const gridApi = useAtomValue(appGridApiAtom);
  const { isPlanInactive } = useIsPlanInactive();

  return (
    <Button
      disabled={isPlanInactive}
      bd={isPlanInactive ? "1px solid var(--mantine-color-gray-4)" : undefined}
      justify="space-between"
      leftSection={<BiSolidAddToQueue size={24} />}
      rightSection={<BiSolidAddToQueue size={24} opacity={0} />}
      size="md"
      onClick={async () => {
        await create();
        gridApi?.applyColumnState(applySortOnCreate);
        logEvent(analytics, `create_${logId}`);
      }}
      loading={loading}
    >
      {label || `Create ${name}`}
    </Button>
  );
};
